$(document).ready(function() {

  if($(window).width() < 768){
    if(!$("body.template-index").hasClass("open_mobile_menu")){
    $(window).scroll(function(){
      if ($(this).scrollTop() > 55) {
        $("body.template-index").addClass("stiky_header");
      } else {
        $("body.template-index").removeClass("stiky_header");
      }
    });
    }
  }

  if($(".cart_popup_button").length > 0){

    $(".cart_popup_button").click(function(){
      $(".cart_popup_block").toggleClass("active");
      $(".mobile-nav-trigger.change").click();
      $("body,html").toggleClass("open_mobile_menu");
    }); 

  }

  $("body").click(function(e) {
    if($(".cart_popup_block").hasClass("active")){
      var container = $(".carticon");        
      if (!container.is(event.target) && !container.has(event.target).length){
        container.find(".cart_popup_block").removeClass("active");
        $("body,html").removeClass("open_mobile_menu");
      }else if($(".cart_popup_block").is(event.target)){
        container.find(".cart_popup_block").removeClass("active");
        $("body,html").removeClass("open_mobile_menu");
      }
    }
  });

  $(".mobile_menu_button").click(function(){
    $(this).toggleClass("change");
    $("body,html").toggleClass("open_mobile_menu1");
  });    

  var Side_cart = {
    click_on_item: false,
    qtyindex: 0,
    init: function(){   
      $(".cart_popup_box").find(".cart_loader").show();       
      Side_cart.get_cart_data();
      Side_cart.side_cart_open();                 
      $(".cart_popup_box").find(".cart_loader").hide();
    },
    side_cart_open: function(){           
      $(".custom_add_to_cart").click(function(e){
        e.preventDefault();                    
        $(".cart_popup_box").find(".cart_loader").show();       
        $("html, body").animate({ scrollTop: 0 }, "slow");
        Side_cart.picks_add_to_cart($(this));
      });
    },
    get_cart_data: function(){
      setTimeout(function(){
        if($(".cart_popup_box .cart_item_block .cart_item .defualt_item").length == 0){
          $.ajax({
            type: "GET",
            dataType: "json",
            url: "/cart.json",
            success: function (data) {
              console.log(data);
              let datature = false;
              let upsell = "";
              let gift = "";
              let zz = 0;
              let ONO = 0;
              let nobor = "";                
              for (let i = 0; i < data.items.length; i++) {
                var No = i + 1;
                if(Side_cart.click_on_item){
                  if(No < 4){
                    var qty = "";
                    if(data.items[i].quantity != 1){ qty = "<br>x" + data.items[i].quantity; }
                    if(No == data.items.length){ nobor = "border-none"; }
                    $(".cart_popup_box .cart_item_block .cart_item").append('<figure class="cart_row item defualt_item ' + nobor + '" data-line="' + No + '" data-id="' + data.items[i].id + '"><a href="' + data.items[i].url + '"><img width="100%" src="' + data.items[i].image + '"><figcaption>' + data.items[i].title + ' ' + qty + '</figcaption></a></figure>');                      
                  }
                  if(No > 3){
                    ONO = ONO + data.items[i].quantity;                 
                    if(ONO == 1){ var OIem = "item"; }else{ var OIem = "items"; }
                    if(No == data.items.length){
                      console.log(ONO);
                      $(".cart_popup_box .cart_item_block .cart_item").append('<p class="other_item_hidden">' + ONO + ' other ' + OIem + ' in bag</p>');
                    }
                  }
                }
                $(".cart_count").text(data.item_count); 
                $(".cart_popup_box").find(".cart_loader").hide();                  
              }
            }
          });
        }              
      }, 1000);
    },
    picks_add_to_cart: function($this){
      $.ajax({
        type: "POST",
        dataType: "json",
        url: "/cart/add.js",            
        data: $this.parents("form").serialize(),
        success: function(data){
          console.log(data);
          Side_cart.click_on_item = true;
          $(".cart_footer .checkout_button").show();
          $(".cart_popup_box .cart_item_block .cart_item").html('');            
          Side_cart.get_cart_data();
        },
        error: function(){
          $(".cart_popup_box").addClass("active");
          $(".cart_popup_box").find(".cart_loader").hide();
        }
      });
    },
    empty_cart: function(){
      setInterval(function(){
        if($(".cart_popup_box .cart_item_block .cart_item .item").length == 0){            
          $(".cart_popup_box .cart_item_block .cart_item .item").hide();
          $(".cart_popup_box .cart_item_block .item_empty").show();
        }else{
          $(".cart_popup_box .cart_item_block .cart_item .item").show();
          $(".cart_popup_box .cart_item_block .item_empty").hide();
        }
      }, 100);
    }
  }
  //Side_cart.init();
  //Side_cart.empty_cart();

  });